import React, { useState, useEffect } from "react";

export const COMPANIES = [
  { key: "qcell", name: "QCell", accent: "#F58220", logo: "https://tse2.mm.bing.net/th/id/OIP.Xg0DfZCinAj6r05He_wYzQHaEi?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },
  { key: "qgroup", name: "QGroup Foundation", accent: "#8B5CF6", logo: "https://tse2.mm.bing.net/th/id/OIP.TiQWU3CagrXktKnaqX-VfgHaKu?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },
  { key: "redcoat", name: "Redcoat Express", accent: "#D81E28", logo: "https://redcoat.co.uk/wp-content/uploads/2024/09/Redcoat_logo.svg" },
  { key: "agib", name: "AGIB Bank", accent: "#0A7C3F", logo: "https://noorynlegacy.com/img/IMG_0637.png" },
  { key: "espace", name: "Espace Motors", accent: "#1F6FEB", logo: "https://tse2.mm.bing.net/th/id/OIP.8o76AO0pFSCra530fXv-rwHaFa?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },
  { key: "qtv", name: "QTV", accent: "#E11D48", logo: "https://tse3.mm.bing.net/th/id/OIP.OBjHFLM3pvCCcZ19wrxPZAHaHa?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },
  { key: "qradio", name: "QRadio", accent: "#7C3AED", logo: "https://zeno.fm/_ipx/_/https://images.zeno.fm/2VkPBCHCvJ2r6y0CUtD0V4I95j0NIAvrErFrrWfZeSY/rs:fill:288:288/g:ce:0:0/aHR0cHM6Ly9wcm94eS56ZW5vLmZtL2NvbnRlbnQvc3RhdGlvbnMvZDA2ODEwODktOWMwMy00NjgzLThjODMtYTk0NWYwZmNhMmYxL2ltYWdlLz91PTE3MzU1MDQ2MjEwMDA.webp" },
  { key: "qcity", name: "QCity", accent: "#16A34A", logo: "https://qcity.gm/themes/demo/assets/images/icon.png" },
  { key: "qmoney", name: "QMoney", accent: "#0EA5E9", logo: "https://salam.gm/webpics/q-money-logo-salam-financial-services.png" },
  { key: "quantumnet", name: "Quantumnet", accent: "#2563EB", logo: "https://directory.africa-business.com/assets/uploadedimages/7371818Logoquanet.jpg" },
  { key: "qrec", name: "QREC", accent: "#9E2A34", logo: "https://www.qrec.gm/images/logo/qrec_logo.png" },
  { key: "salaam", name: "Salaam Construction", accent: "#B8860B", logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_darkglass-sign/artifacts/zesclxr8_Logo%20Photo.jpg" },
];

export const companyName = (key) =>
  COMPANIES.find((c) => c.key === key)?.name || key;
export const companyAccent = (key) =>
  COMPANIES.find((c) => c.key === key)?.accent || "#8B8680";

// Runtime logo overrides (admin can change company logos). Resolved at render time.
let LOGO_OVERRIDES = {};
export const setLogoOverrides = (m) => {
  LOGO_OVERRIDES = m || {};
};
export const resolveLogo = (company) =>
  (company && (LOGO_OVERRIDES[company.key] || company.logo)) || "";

export const CompanyLogo = ({ company, className = "" }) => {
  const src = resolveLogo(company);
  const [err, setErr] = useState(false);
  useEffect(() => {
    setErr(false);
  }, [src]);
  return (
    <span
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white ${className}`}
    >
      {err ? (
        <span className="text-xs font-bold text-[#1A1815]">
          {company.name.charAt(0)}
        </span>
      ) : (
        <img
          src={src}
          alt={company.name}
          onError={() => setErr(true)}
          className="h-full w-full object-contain p-0.5"
        />
      )}
    </span>
  );
};
